import request from '@/utils/request'

export function getPracticeMenus() {
    return request({
        url: 'api/practiceMenus',
        method: 'get'
    })
}

export function deletePracticeMenus(type, id) {
    return request({
        url: 'api/practiceMenus/' + type + '/' + id,
        method: 'delete'
    })
}

export function postPracticeMenus(data) {
    return request({
        url: 'api/practiceMenus',
        method: 'post',
        data
    })
}

export function postPracticeMenusName(data) { //修改科目
    return request({
        url: 'api/practiceMenusName',
        method: 'post',
        data
    })
}

export function deletePracticeMenusName(data) { //删除科目
    return request({
        url: 'api/practiceMenusName',
        method: 'delete',
        data
    })
}

export function getPracticeMenusList(id) { //查询list
    return request({
        url: 'api/practiceMenusList/' + id,
        method: 'get'
    })
}

export function postUpdatePracticeMenus(data) {
    return request({
        url: 'api/updatePracticeMenus',
        method: 'post',
        data
    })
}

export function getThesaurusChoice(params) {
    return request({
        url: 'api/thesaurusChoice?' + params,
        method: 'get'
    })
}